import { render, staticRenderFns } from "./BrokersForm.vue?vue&type=template&id=33b45b3b&scoped=true"
import script from "./BrokersForm.vue?vue&type=script&lang=js"
export * from "./BrokersForm.vue?vue&type=script&lang=js"
import style0 from "./BrokersForm.vue?vue&type=style&index=0&id=33b45b3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b45b3b",
  null
  
)

export default component.exports